import React, {Fragment} from 'react';
import PageTitle from "./PageTitle";
import {Link} from 'react-router-dom';
import SocialNetworks from "./SocialNetworks";

export default function About(props) {
    return(
      <Fragment>
          <PageTitle title={"About"}/>
          <section className="hero-min-fullscreen bg-lines flex-center py-8 px-5">
              <div className="container p-0">
                  <div className="row no-gutters flex-center">

                      <div className="col-md-6 align-self-start" data-animation="fade-in-left 1s .2s">
                          <img src="img/pro_pic_vertical.jpg" className="radius-1 shadow-1"
                               alt="cutiko foto de perfil"/>
                      </div>

                      <div className="col-md-6 px-0 px-md-5 px-lg-7" data-animation="fade-in-left 1s .4s">
                          <p className="small bold mb-5">Android, React y Firebase</p>
                          <h2 className="bold">Freelancer especialista en MVPs</h2>
                          <hr className="separator-left"/>
                          <p>Mi especialidad es sacar adelante MVPs usando serverless</p>
                          <p>Tengo más de 6 años de experiencia</p>
                          <p>He trabajado en B2B y en C2C</p>
                          <p>He llegado a estar en el 5% superior de StackOverflow</p>
                          <p>Cuando puedo contribuyo al open source en Github</p>

                          <p className="small serif text-links mt-5">
                              <SocialNetworks/>
                          </p>

                          <Link to="/contact" className="button style-6 mt-6">Escríbeme</Link>
                      </div>
                  </div>
              </div>
          </section>
      </Fragment>
    );
}


// WEBPACK FOOTER //
// ./src/visitors/components/About.js